import { render } from "./AutoMonitor.vue?vue&type=template&id=1b71832e&scoped=true"
import script from "./AutoMonitor.vue?vue&type=script&lang=js"
export * from "./AutoMonitor.vue?vue&type=script&lang=js"

import "./AutoMonitor.vue?vue&type=style&index=0&id=1b71832e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b71832e"]])

export default __exports__